import { render, staticRenderFns } from "./testMpago.vue?vue&type=template&id=22925a99&"
import script from "./testMpago.vue?vue&type=script&lang=js&"
export * from "./testMpago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports